export default __webpack_public_path__ + "static/media/homepage-hero-1.6654afb6.mp4";